<template>
<div class="col-12 text-left">
    <app-nav-bar></app-nav-bar>
    <div class="main-content">
         <h3 class="p-2">
            <small class="text-muted">Customer Complaint - Dashboard View</small>
        </h3>
        <div class="p-2 dropdown-divider"></div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Complaint Number</label>
                <input type="text" class="form-control" id="complaint-no" v-model="ccq.complaintNo" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">CCF Log Date</label>
                <!-- <input type="text" class="form-control" id="reported-date" v-model="ccq.reportedDate" disabled> -->
                <flat-pickr class="form-control" id="reported-date" v-model="ccq.reportedDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Distributed to Internal</label>
                <!-- <input type="text" class="form-control" id="distributed-internal" v-model="ccq.distributedToInternal" disabled> -->
                <flat-pickr class="form-control" id="distributed-internal" v-model="ccq.distributedToInternal" disabled></flat-pickr>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
            <label for="subject">Customer</label>
            <input type="text" class="form-control" id="customer" v-model="ccq.customerName" disabled>
            </div>
            <div class="form-group col-3">
            <label for="subject">Brand</label>
            <input type="text" class="form-control" id="brand" v-model="ccq.productName" disabled>
            </div>
            <div class="form-group col-3">
            <label for="subject">Product</label>
            <input type="text" class="form-control" id="product" v-model="ccq.productName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-3">
                <label for="module">Address</label>
                <textarea class="form-control" id="address" v-model="ccq.address" rows="2" disabled></textarea>
            </div>
            <div class="form-group col-3">
                <label for="module">PIC</label>
                <input type="text" class="form-control" id="pic" v-model="ccq.pic" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Email</label>
                <input type="text" class="form-control" id="email" v-model="ccq.email" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Phone</label>
                <input type="text" class="form-control" id="phone" v-model="ccq.phone" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="subject">Plant</label>
                <input type="text" class="form-control" id="plant" v-model="ccq.plantName" disabled>
            </div>
            <div class="form-group col-6">
                <label for="subject">Packaging</label>
                <input type="text" class="form-control" id="packaging" v-model="ccq.packagingName" disabled>
            </div>
        </div>
        <!-- <div class="row">
            <div class="form-group col-3">
                <label for="module">PO</label>
                <input type="text" class="form-control" id="po" v-model="ccq.po" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">SO</label>
                <input type="text" class="form-control" id="so" v-model="ccq.so" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Batch</label>
                <input type="text" class="form-control" id="batch" v-model="ccq.batch" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Qty.</label>
                <input type="number" class="form-control" id="qty" v-model="ccq.qty" disabled>
            </div>
        </div> -->
        <div class="row">
            <div class="form-group col-3">
                <label for="module">BL Date</label>
                <!-- <input type="text" class="form-control" id="bl-date" v-model="ccq.blDate" disabled> -->
                <flat-pickr class="form-control" id="bl-date" v-model="ccq.blDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Dispatch Date</label>
                <!-- <input type="text" class="form-control" id="dispatch-date" v-model="ccq.dispatchDate" disabled> -->
                <flat-pickr class="form-control" id="dispatch-date" v-model="ccq.dispatchDate" disabled></flat-pickr>
            </div>
            <div class="form-group col-3">
                <label for="module">Discharge Port</label>
                <input type="text" class="form-control" id="discharge-port" v-model="ccq.dischargePortName" disabled>
            </div>
            <div class="form-group col-3">
                <label for="module">Container No.</label>
                <input type="text" class="form-control" id="container-no" v-model="ccq.containerNo" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <label for="module">Country Name</label>
                <input type="text" class="form-control" id="country" v-model="ccq.countryName" disabled>
            </div>
            <div class="form-group col-6">
                <label for="module">Incoterms</label>
                <input type="text" class="form-control" id="model-of-delivery" v-model="ccq.modelOfDeliveryName" disabled>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-4">
                <label for="module">Non Conformance Type</label>
                <input type="text" class="form-control" id="conformance-type" v-model="ccq.conformanceTypeName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Complaint Media</label>
                <input type="text" class="form-control" id="complaint-media" v-model="ccq.complaintMediaName" disabled>
            </div>
            <div class="form-group col-4">
                <label for="module">Enclosed</label>
                <input type="text" class="form-control" id="enclosed" v-model="ccq.enclosedName" disabled>
            </div>
        </div>
         <div class="row">
            <div class="form-group col-12">
                <label for="module">Description</label>
                <textarea class="form-control" id="description" v-model="ccq.description" rows="3" disabled></textarea>
            </div>
        </div>
        Customer Complaint Detail
        <app-datatable :type="'view'" :newData="newCustomerComplaintDetail" :elements="dtElementsDetail" :collections="ccq.customerComplaintDetail"></app-datatable>
        <br /><br />
        Investigation Data
        <app-datatable :type="'view'" :newData="newCustomerComplaintInvestigationDetail" :elements="dtElementsCCInvestigation" :collections="ccq.customerComplaintInvestigationDetail"></app-datatable>
        <br />
        <div class="row">
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccSalesAttachment !== ''" class="form-group col-3">
               <a :href="this.ccq.ccSalesAttachment" class="badge badge-primary">Download Attachment from Sales</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccSalesAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Sales</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment !== ''" class="form-group col-3">
               <a :href="this.ccq.ccAreaOwnerAttachment" class="badge badge-primary">Download Attachment from Quality</a>
            </div>
            <div v-if="this.$route.query.id !== undefined && this.ccq.ccAreaOwnerAttachment === ''" class="form-group col-3">
               <a style="color: white;" class="badge badge-secondary">No Attachment from Quality</a>
            </div>
        </div>
        <br />
        <!-- Corrective Internal Data
        <app-datatable :type="'view'" :newData="newCorrectiveInternal" :elements="dtElementsInternal" :collections="ccq.customerComplaintCorrectiveInternal"></app-datatable>
        <br /><br /> -->
        Root Cause Analysys & Corrective and Preventive Action Internal Data
        <app-datatable :type="'view'" :newData="newCorrectivePreventiveInternal" :elements="dtElementsCorrectivePreventiveInternal" :collections="ccq.correctivePreventiveInternal"></app-datatable>
        <br /><br />
        <!-- Corrective External Data
        <app-datatable :type="'view'" :newData="newCorrectiveExternal" :elements="dtElementsExternal" :collections="ccq.customerComplaintCorrectiveExternal"></app-datatable>
        <br /><br /> -->
        <!-- Action Tracker Data
        <app-datatable :type="'view'" :newData="newCustomerComplaintActionTracker" :elements="dtElementsActionTracker" :collections="ccq.customerComplaintActionTracker"></app-datatable>
        <br /><br /> -->
        Action Tracker Log (Revision)
        <app-datatable :type="'view'" :newData="newCustomerComplaintActionTrackerLog" :elements="dtElementsActionTrackerLog" :collections="ccq.customerComplaintActionTrackerLog"></app-datatable>
        <br /><br />
    </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintQuality, customerComplaintDetail, customerComplaintInvestigationDetail, 
        customerComplaintCorrectiveExternal, customerComplaintCorrectiveInternal, customerComplaintActionTracker, 
        customerComplaintActionTrackerLog, correctivePreventiveInternal } from '../../models/customerComplaintQuality'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import AppDatatable from '../../components/AppDatatable.vue'

export default {
    components: {
        AppLookupField, AppDatePicker, AppNavBar, AppDropdown, AppDatatable
    },
    data() {
        return {
          ccq: {...customerComplaintQuality, 
                customerComplaintDetail: [],
                customerComplaintInvestigationDetail: [], 
                customerComplaintCorrectiveExternal: [], 
                customerComplaintCorrectiveInternal: [], 
                customerComplaintActionTracker: [],
                customerComplaintActionTrackerLog: [],
                correctivePreventiveInternal: []},
          newCustomerComplaintDetail: customerComplaintDetail,
          newCustomerComplaintInvestigationDetail: customerComplaintInvestigationDetail,
          newCustomerComplaintActionTracker: customerComplaintActionTracker,
          newCustomerComplaintActionTrackerLog: customerComplaintActionTrackerLog,
          newCorrectiveExternal: customerComplaintCorrectiveExternal,
          newCorrectiveInternal: customerComplaintCorrectiveInternal,
          newCorrectivePreventiveInternal: correctivePreventiveInternal,
          dtElementsDetail: [
                {
                    title: 'PO',
                    column: 'po',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'SO',
                    column: 'so',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Batch',
                    column: 'batch',
                    type: 'text',
                    width: 6,
                },
                {
                    title: 'Qty',
                    column: 'qty',
                    type: 'text',
                    width: 6,
                },
          ],
          dtElementsInternal: [
              {
                title: 'Corrective Action Number',
                column: 'correctiveActionNumber',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'dropdown',
                width: 6,
                lists: [
                    {
                        title: 'Machine',
                        value: 'machine'
                    },
                    {
                        title: 'Man',
                        value: 'man'
                    },
                    {
                        title: 'Material',
                        value: 'material'
                    },
                    {
                        title: 'Method',
                        value: 'method'
                    },
                    {
                        title: 'Environment',
                        value: 'environment'
                    }
                ]
              },
              {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 6,
              },
              {
                title: 'Corrective Responder Name',
                column: 'correctiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberCorrective',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Corrective Responder Name',
                            width: 5,
                            column: 'correctiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'correctivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'correctiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'correctiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Corrective Responder Email',
                column: 'correctiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Corrective Target Date',
                column: 'correctiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 6,
              },
              {
                title: 'Preventive Responder Name',
                column: 'preventiveResponderName',
                type: 'lookup',
                width: 6,
                lookup: {
                    id: 'memberPreventive',
                    title: 'Member Data',
                    type: 'table',
                    apiUrl: 'member-management/lookup',
                    filter: ['firstName', 'lastName', 'email'],
                    fields: [
                        {
                            placeholder: 'Preventive Responder Name',
                            width: 5,
                            column: 'preventiveResponderName'
                        }
                    ],
                    dtElements: [
                        {
                            title: 'First Name',
                            column: 'firstName'
                        },
                        {
                            title: 'Last Name',
                            column: 'lastName'
                        },
                        {
                            title: 'Email',
                            column: 'email'
                        },
                    ],
                    affectedField: [
                        {
                            from: 'id',
                            to: 'preventivePicId'
                        },
                        {
                            from: 'firstName',
                            to: 'preventiveResponderName'
                        },
                        {
                            from: 'email',
                            to: 'preventiveResponderEmail'
                        },
                    ]
                },
                disable: true,
              },
              {
                title: 'Preventive Responder Email',
                column: 'preventiveResponderEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Preventive Target Date',
                column: 'preventiveTargetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
          dtElementsCorrectivePreventiveInternal: [
              {
                title: 'Action No.',
                column: 'actionNo',
                type: 'text',
                width: 4,
                disable: true
              },
              {
                title: 'Root Cause Type',
                column: 'rootCauseType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Root Cause Remark',
                column: 'rootCauseRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Type',
                column: 'actionType',
                type: 'text',
                width: 6,
              },
              {
                title: 'Action Remark',
                column: 'actionRemark',
                type: 'text',
                width: 6,
              },
              {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
              },
              {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
              },
              {
                title: 'Responder Name',
                column: 'picName',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'PIC Email',
                column: 'picEmail',
                type: 'text',
                width: 4,
                disable: true,
              },
              {
                title: 'Target Date',
                column: 'targetDate',
                type: 'date',
                width: 4,
                disable: true,
              },
          ],
          dtElementsExternal: [
            {
                title: 'Investigation Detail',
                column: 'investigationDetail',
                type: 'text',
                width: 8,
            },
            {
                title: 'Corrective',
                column: 'corrective',
                type: 'text',
                width: 8,
            },
            {
                title: 'Preventive',
                column: 'preventive',
                type: 'text',
                width: 8,
            },
          ],
          dtElementsCCInvestigation: [
              {
                  title: 'Question',
                  column: 'question',
                  type: 'text',
                  width: 6,
              },
              {
                  title: 'Responder',
                  column: 'responder',
                  type: 'lookup',
                  width: 6,
                  lookup: {
                      id: 'member',
                      title: 'Member Data',
                      type: 'table',
                      apiUrl: 'member-management/lookup',
                      filter: ['firstName', 'lastName', 'email'],
                      fields: [
                          {
                              placeholder: 'Responder',
                              width: 5,
                              column: 'responder'
                          }
                      ],
                      dtElements: [
                          {
                              title: 'First Name',
                              column: 'firstName'
                          },
                          {
                              title: 'Last Name',
                              column: 'lastName'
                          },
                          {
                              title: 'Email',
                              column: 'email'
                          },
                      ],
                      affectedField: [
                          {
                              from: 'id',
                              to: 'memberId'
                          },
                          {
                              from: 'firstName',
                              to: 'responder'
                          },
                          {
                              from: 'email',
                              to: 'email'
                          },
                      ]
                  },
                  disable: true,
              },
              {
                  title: 'Email',
                  column: 'email',
                  type: 'text',
                  width: 4,
                  disable: true,
              },
              {
                  title: 'Answer',
                  column: 'answer',
                  type: 'text',
                  width: 4,
                  disable: true,
              },
              {
                title: 'Attachment',
                column: 'attachment',
                type: 'link'
              },
              {
                  title: 'Answered At',
                  column: 'answeredAt',
                  type: 'date',
                  width: 4,
                  disable: true,
              },
          ],
          dtElementsActionTracker: [
            {
                title: 'Corrective Action Number',
                column: 'correctiveActionNumber',
                type: 'text',
                width: 4,
                disable: true
            },
            {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'text',
                width: 6,
            },
            {
                title: 'Type',
                column: 'type',
                type: 'text',
                width: 6,
            },
            {
                title: 'PIC',
                column: 'pic',
                type: 'text',
                width: 6,
            },
            {
                title: 'Email',
                column: 'email',
                type: 'text',
                width: 6,
            },
            {
                title: 'Work Description',
                column: 'workDescription',
                type: 'text',
                width: 6,
            },
            {
                title: 'Evidence',
                column: 'evidence',
                type: 'link',
                width: 6,
            },
            {
                title: 'Completion Date',
                column: 'completionDate',
                type: 'date',
                width: 4,
            },
          ],
          dtElementsActionTrackerLog: [
            {
                title: 'PIC',
                column: 'pic',
                type: 'text',
                width: 6,
            },
            {
                title: 'Email',
                column: 'email',
                type: 'text',
                width: 6,
            },
            {
                title: 'Root Cause',
                column: 'rootCause',
                type: 'text',
                width: 6,
            },
            {
                title: 'Type',
                column: 'type',
                type: 'text',
                width: 6,
            },
            {
                title: 'Item',
                column: 'item',
                type: 'text',
                width: 6,
            },
            {
                title: 'Comment',
                column: 'remark',
                type: 'text',
                width: 6,
            },
            {
                title: 'Revised by User',
                column: 'isAnswered',
                type: 'text',
                width: 6,
            },
          ],
        }
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const ccqApi = api('ccf-dashboard')
            this.ccq = await ccqApi.getWithParams(this.$route.query.id)
        }
    },
    methods: {
        cancel() {
            this.$router.go(-1)
        },
        finishLookup(data) {
            const currentccq = this.ccq
            this.ccq = {
                ...currentccq,
                ...data
            }
        }
    }
}
</script>